import Vue from 'vue'
import Vuex from 'vuex'
import system from './system'
import users from './users'
import ddmasters from './DDMasters'

// added by yam for login screen
import usersBeforeLogin from './usersBeforeLogin'
import tempData from './tempData'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    users: users,
    system: system,
    DDMasters: ddmasters,
    usersBeforeLogin: usersBeforeLogin,
    tempData: tempData
  }
})
